<style lang="scss" src="./Bento.scss"></style>

<script>
	import Simple from '@/components/Simple/Simple';
	import { Helper } from '@/services/helper/helper';

	/**
	 * Bento menu for changing login type.
	 * @vue-data {string} id An unique identifier for the component instance
	 * @vue-data {Object} elements An object containing the structure of the elements to be inserted into bento menu
	 * @vue-data {Object[]} footer An array of footer element objects
	 * @vue-data {string} brandName The name of the current brand
	 * @vue-data {number} chosen The currently chosen login type. NOT USED!
	 * @listens Document#click
	 */
	export default {
		name: 'HpBento',
		data () {
			return {
				id: this._uid,
				// JSON.parse required because BE can't print \n they only can do \\n if we want predefined line-breaks HOMEPAGE-3689
				elements: JSON.parse(JSON.stringify(this.$initialData.bento).replace('\\\\n', '\\n')),
				footer: this.$initialData.bentoFooter,
				brandName: ''
			};
		},
		components: {
			'hp-simple': Simple
		},
		methods: {
			/**
			 * Toggles the login type.
			 * @param {Event} event - The click event fired on bento menu element click
			 * @param {number} row - The row of the chosen bento menu element
			 * @param {number} col - The column of the chosen bento menu element
			 */
			toggleLogin (event, row, col) {
				let newURL = this.getUrlFromParent(event.target);
				if (newURL) {
					event.preventDefault();
					this.$emit('change', this.elements[row][col]);

					let loginElement = document.querySelector('[data-component="login"]');

					for (let i = 0; i < loginElement.children.length; i++) {
						if (loginElement.children[i].hasAttribute('data-form-login')) {
							loginElement.children[i].action = newURL;

							// open the Login if in header and close the bento menu
							let bento = Helper.getElementByAttribute(event.target, '[data-component="bento"]');
							if (!bento) {
								return;
							}

							bento.getElementsByTagName('input')[0].checked = false;

							// change text in login
							let eventTargetParent = Helper.getElementByAttribute(event.target, '[data-component="simple"]');
							let newText = eventTargetParent.getElementsByTagName('figcaption')[0].innerHTML;
							document.querySelector('[data-login-text]').innerHTML = newText;

							// change icon in login
							let newIcon = eventTargetParent.querySelector('[data-component="icon"]').cloneNode(true);
							document.querySelector('[data-login-icon]').innerHTML = '';
							document.querySelector('[data-login-icon]').appendChild(newIcon);

							this.createHiddenValuesAndChangeLink(row, col);
							break;
						}
					}
				} // else it's just a normal link going somewhere... bye bye
			},
			/**
			 * ???
			 * @param {Element} element The element to get the parent element of
			 * @returns {string|Element} Either the value of href if it's an clickout or the parent element if it's a login change
			 * @see {@link Helper.getElementByAttribute}
			 */
			getUrlFromParent (element) {
				let parent = Helper.getElementByAttribute(element, '[data-login]');
				return parent !== undefined ? parent.getAttribute('href') : parent;
			},
			/**
			 * Creates the hidden inputs for login based on bento menu element identified by row and column.
			 * @param {number} row The row of the bento menu element
			 * @param {number} col The column of the bento menu element
			 */
			createHiddenValuesAndChangeLink (row, col) {
				const currentBentoPoint = this.elements[row][col];

				// Hidden Values
				const container = document.querySelector('[data-hidden-values]');
				const params = currentBentoPoint.formHiddenParams;
				let letMeIn = '';
				for (let key in params) {
					if (params.hasOwnProperty(key)) {
						letMeIn += '<input type="hidden" name="' + key + '" value="' + params[key] + '">';
					}
				}

				container.innerHTML = letMeIn;

				// Link
				const form = document.querySelector('[data-form-login]');
				form.setAttribute('action', currentBentoPoint.link.href);
			},
			checkClicks () {
				let clickCount = 0;

				this.$el.querySelector('label')?.addEventListener('click', () => {
					clickCount++;

					if (clickCount === 50) {
						this.$el.classList.add('rotate');

						setTimeout(() => {
							this.$el.classList.remove('rotate');
							clickCount = 0;
						}, 1000);
					}
				});
			}
		},
		mounted () {
			this.brandName = process.env.VUE_APP_BRAND_NAME;

			this.checkClicks();

			this.$nextTick(() => {
				document.addEventListener('click', (event) => {
					Helper.uncheckOnOutsideClick(event, this.$el);
				});
				// simulate click on first login type to set correct initial field values
				this.$el.querySelector('[data-part="bento-tile"] a div').click();
			});
		}
	};
</script>

<template>
	<div data-component="bento">
		<input :id="'bento' + id" data-hidden type="checkbox" />
		<label :for="'bento' + id">
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
			<span></span>
		</label>
		<div data-layer>
			<label :for="'bento' + id" data-close-button data-grid-end-self>
				<span></span>
				<span></span>
			</label>
			<div :key="index" data-grid-row data-part="bento-row" v-for="(row, index) in elements">
				<div :key="index2" @click="toggleLogin($event, index, index2)" data-part="bento-tile" v-for="(element, index2) in row">
					<hp-simple v-bind="element"></hp-simple>
				</div>
			</div>
			<div data-grid-row data-part="bento-row">
				<a :href="el.href" :key="index" v-for="(el, index) in footer">{{ el.text }}</a>
			</div>
		</div>
	</div>
</template>
